import React, { useState, useCallback, useContext, useEffect } from "react";
import { toast } from "react-toastify";
import { showInfoToast, showSuccessToast, showWarningToast } from "../../utils/toastHelper";
import { add, format, parseISO } from "date-fns";
import ColorModeContext from "../../layout/themeContext";
import { createGradientStyles } from "../../utils/themeColors";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
// import { SocketContext } from "../../context/Socket/SocketContext";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import {
  Button,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Table,
  TableHead,
  Paper,
  Tooltip,
  Typography,
  CircularProgress,
  Box,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Select,
  MenuItem as MuiMenuItem,
  FormControl,
  InputLabel,
  Switch,
} from "@material-ui/core";
import {
  Edit,
  CheckCircle,
  SignalCellularConnectedNoInternet2Bar,
  SignalCellularConnectedNoInternet0Bar,
  SignalCellular4Bar,
  CropFree,
  DeleteOutline,
  Facebook,
  Instagram,
  WhatsApp,
  Sync,
  PowerSettingsNew,
  Search,
} from "@material-ui/icons";
import WebhookIcon from '@mui/icons-material/Webhook';
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

import PageBase from "../../components/PageBase";
import TableRowSkeleton from "../../components/TableRowSkeleton";

import api from "../../services/api";
import WhatsAppModal from "../../components/WhatsAppModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import QrcodeModal from "../../components/QrcodeModal";
import { i18n } from "../../translate/i18n";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";
import toastError from "../../errors/toastError";
import formatSerializedId, { FormattedPhoneNumber } from '../../utils/formatSerializedId';
import { AuthContext } from "../../context/Auth/AuthContext";
import usePlans from "../../hooks/usePlans";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ForbiddenPage from "../../components/ForbiddenPage";
import { Can } from "../../components/Can";

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    // padding: theme.spacing(1),
    padding: theme.padding,
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
  customTableCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: theme.typography.pxToRem(14),
    border: "1px solid #dadde9",
    maxWidth: 450,
  },
  tooltipPopper: {
    textAlign: "center",
  },
  buttonProgress: {
    color: green[500],
  },
  // ✅ CORREÇÃO: Estilos do modal seguindo padrão do NewTicketModal
  dialogTitle: {
    padding: theme.spacing(2, 3),
    '& .MuiTypography-root': {
      fontWeight: 600,
      fontSize: '1.2rem'
    }
  },
  ...createGradientStyles(theme),
  dialogContent: {
    padding: theme.spacing(3),
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.background.default : '#fafafa'
  },
  dialogActions: {
    padding: theme.spacing(2, 3),
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.background.default : '#f5f5f5',
    borderTop: theme.palette.type === 'dark' ? '1px solid #444' : '1px solid #e0e0e0'
  },
}));

function CircularProgressWithLabel(props) {
  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress variant="determinate" {...props} />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          variant="caption"
          component="div"
          color="textSecondary"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

const CustomToolTip = ({ title, content, children }) => {
  const classes = useStyles();

  return (
    <Tooltip
      arrow
      classes={{
        tooltip: classes.tooltip,
        popper: classes.tooltipPopper,
      }}
      title={
        <React.Fragment>
          <Typography gutterBottom color="inherit">
            {title}
          </Typography>
          {content && <Typography>{content}</Typography>}
        </React.Fragment>
      }
    >
      {children}
    </Tooltip>
  );
};

const IconChannel = (channel) => {
  switch (channel) {
    case "facebook":
      return (
        <Tooltip title={i18n.t("connections.tooltips.channelFacebook")}>
          <Facebook style={{ color: "#3b5998" }} />
        </Tooltip>
      );
    case "instagram":
      return (
        <Tooltip title={i18n.t("connections.tooltips.channelInstagram")}>
          <Instagram style={{ color: "#e1306c" }} />
        </Tooltip>
      );
    case "whatsapp":
      return (
        <Tooltip title={i18n.t("connections.tooltips.channelWhatsapp")}>
          <WhatsApp style={{ color: "#25d366" }} />
        </Tooltip>
      );
    case "whatsapp_oficial":
      return (
        <Tooltip title={i18n.t("connections.tooltips.channelWhatsappOfficial")}>
          <WhatsApp style={{ color: "#25d366" }} />
        </Tooltip>
      );
    default:
      return "error";
  }
};

const Connections = () => {
  const classes = useStyles();
  const theme = useTheme();
  const colorModeContext = useContext(ColorModeContext);
  const useGradient = colorModeContext?.useGradient || theme.palette?.gradient || false;

  const { whatsApps, loading } = useContext(WhatsAppsContext);
  const [whatsAppModalOpen, setWhatsAppModalOpen] = useState(false);
  const [statusImport, setStatusImport] = useState([]);
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [selectedWhatsApp, setSelectedWhatsApp] = useState(null);
  const [channel, setChannel] = useState("whatsapp");
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const history = useHistory();
  const confirmationModalInitialState = {
    action: "",
    title: "",
    message: "",
    whatsAppId: "",
    open: false,
  };
  const [confirmModalInfo, setConfirmModalInfo] = useState(confirmationModalInitialState);
  const [planConfig, setPlanConfig] = useState(false);
  const [transferModalOpen, setTransferModalOpen] = useState(false);
  const [sourceConnection, setSourceConnection] = useState("");
  const [targetConnection, setTargetConnection] = useState("");
  const [preDeleteModalOpen, setPreDeleteModalOpen] = useState(false);
  const [whatsAppToDelete, setWhatsAppToDelete] = useState(null);
  const [transferProgressModalOpen, setTransferProgressModalOpen] = useState(false);
  const [transferProgress, setTransferProgress] = useState({ current: 0, total: 0, percentage: 0 });
  const [contactsImportModalOpen, setContactsImportModalOpen] = useState(false);
  const [contactsImportData, setContactsImportData] = useState(null);
  const [diagnosticModalOpen, setDiagnosticModalOpen] = useState(false);
  const [diagnosticData, setDiagnosticData] = useState(null);
  const [connectionActionLoading, setConnectionActionLoading] = useState({});
  const [qrSafetyModalOpen, setQrSafetyModalOpen] = useState(false);
  const [qrSafetyWhatsApp, setQrSafetyWhatsApp] = useState(null);
  const [forceGenerateQrOnOpen, setForceGenerateQrOnOpen] = useState(false);

  //   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);

  const companyId = user.companyId;

  const { getPlanCompany } = usePlans();

  useEffect(() => {
    async function fetchData() {
      const planConfigs = await getPlanCompany(undefined, companyId);
      setPlanConfig(planConfigs)
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const responseFacebook = (response) => {
    if (response.status !== "unknown") {
      const { accessToken, id } = response;

      api
        .post("/facebook", {
          facebookUserId: id,
          facebookUserToken: accessToken,
        })
        .then((response) => {
          showSuccessToast(i18n.t("connections.facebook.success"));
        })
        .catch((error) => {
          toastError(error);
        });
    }
  };

  const responseInstagram = (response) => {
    if (response.status !== "unknown") {
      const { accessToken, id } = response;

      api
        .post("/facebook", {
          addInstagram: true,
          facebookUserId: id,
          facebookUserToken: accessToken,
        })
        .then((response) => {
          showSuccessToast(i18n.t("connections.facebook.success"));
        })
        .catch((error) => {
          toastError(error);
        });
    }
  };

  useEffect(() => {
    // const socket = socketManager.GetSocket();

    socket.on(`importMessages-${user.companyId}`, (data) => {
      if (data.action === "refresh") {
        setStatusImport([]);
        history.go(0);
      }
      if (data.action === "update") {
        setStatusImport(data.status);
      }
    });

    socket.on(`transferTickets-${user.companyId}`, (data) => {
      if (data.action === "progress") {
        setTransferProgress({
          current: data.current,
          total: data.total,
          percentage: Math.round((data.current / data.total) * 100)
        });
      }
      if (data.action === "completed") {
        setTransferProgressModalOpen(false);
        setTransferProgress({ current: 0, total: 0, percentage: 0 });
        showSuccessToast(`Transferência concluída! ${data.transferred} tickets transferidos com sucesso.`);
        handleCloseTransferModal();
      }
      if (data.action === "error") {
        setTransferProgressModalOpen(false);
        setTransferProgress({ current: 0, total: 0, percentage: 0 });
        toastError("Erro na transferência de tickets.");
      }
    });

    const whatsappSessionEventName = `company-${user.companyId}-whatsappSession`;
    const handleWhatsappSessionDiagnostic = (data) => {
      if (data?.action !== "diagnostic_progress" || !data?.diagnostic) return;

      setDiagnosticData((prev) => ({
        ...(prev || {}),
        diagnosticState: data.diagnostic.state,
        finalState: data.diagnostic.state,
        autoResult: {
          ...(prev?.autoResult || {}),
          diagnosticId: data.diagnostic.diagnosticId,
          finalState: data.diagnostic.state,
          message: data.diagnostic.message,
          qrAvailable: data.diagnostic.qrAvailable,
          qrcodeLength: data.diagnostic.qrcodeLength
        }
      }));
      setDiagnosticModalOpen(true);
    };

    socket.on(whatsappSessionEventName, handleWhatsappSessionDiagnostic);

    // ✅ NOVO: Listener para confirmação de importação de contatos
    const contactsImportEventName = `company-${user.companyId}-contactsImportConfirmation`;
    console.log("[CONTACTS_IMPORT] Registering listener for:", contactsImportEventName, "socket connected:", socket?.connected);
    
    socket.on(contactsImportEventName, (data) => {
      console.log("[CONTACTS_IMPORT] Event received:", data);
      
      if (data.action === "ask") {
        console.log("[CONTACTS_IMPORT] Opening modal with data:", {
          whatsappId: data.whatsappId,
          totalContacts: data.totalContacts,
          message: data.message
        });
        
        setContactsImportData(data);
        setContactsImportModalOpen(true);
        
        // Mostrar toast para garantir que usuário veja
        showInfoToast(`Encontramos ${data.totalContacts || 0} contatos no WhatsApp. Verifique o modal para importá-los.`, {
          autoClose: 5000
        });
      }
    });

    return () => {
      socket.off(`company-${user.companyId}-contactsImportConfirmation`);
      socket.off(whatsappSessionEventName, handleWhatsappSessionDiagnostic);
    };
  }, [whatsApps, user.companyId, socket]);

  const handleStartWhatsAppSession = (whatsApp) => {
    handleRepairConnection(whatsApp);
  };

  const handleRequestNewQrCode = async (whatsApp) => {
    try {
      setConnectionActionLoading((prev) => ({ ...prev, [`qr-${whatsApp.id}`]: true }));
      const { data } = await api.get(`/whatsappsession/${whatsApp.id}/diagnose`);
      if (data?.authState?.redisHasCreds || data?.authState?.backupValid) {
        setDiagnosticData(data);
        setQrSafetyWhatsApp(whatsApp);
        setQrSafetyModalOpen(true);
        return;
      }
      setForceGenerateQrOnOpen(true);
      setSelectedWhatsApp(whatsApp);
      setQrModalOpen(true);
    } catch (err) {
      toastError(err);
    } finally {
      setConnectionActionLoading((prev) => ({ ...prev, [`qr-${whatsApp.id}`]: false }));
    }
  };

  const handleGenerateQrAnyway = (whatsApp) => {
    setQrSafetyModalOpen(false);
    setQrSafetyWhatsApp(null);
    setForceGenerateQrOnOpen(true);
    setSelectedWhatsApp(whatsApp);
    setQrModalOpen(true);
  };

  const handleOpenWhatsAppModal = (channel) => {
    setChannel(channel)
    setSelectedWhatsApp(null);
    setWhatsAppModalOpen(true);
  };

  const handleCloseWhatsAppModal = useCallback(() => {
    setWhatsAppModalOpen(false);
    setSelectedWhatsApp(null);
  }, [setSelectedWhatsApp, setWhatsAppModalOpen]);

  const handleOpenQrModal = (whatsApp) => {
    setForceGenerateQrOnOpen(false);
    setSelectedWhatsApp(whatsApp);
    setQrModalOpen(true);
  };

  const handleCloseQrModal = useCallback(() => {
    setSelectedWhatsApp(null);
    setQrModalOpen(false);
    setForceGenerateQrOnOpen(false);
  }, [setQrModalOpen, setSelectedWhatsApp]);

  const handleEditWhatsApp = (whatsApp) => {
    setChannel(whatsApp.channel)
    setSelectedWhatsApp(whatsApp);
    setWhatsAppModalOpen(true);
  };

  const handleSyncTemplates = async (whatsAppId) => {
    await api.get(`/whatsapp/sync-templates/${whatsAppId}`);
  };

  const handleConfirmContactsImport = async () => {
    try {
      setContactsImportModalOpen(false);
      
      // Chamar API para iniciar importação
      await api.post(`/whatsappsession/${contactsImportData.whatsappId}/import-contacts`);
      
      showSuccessToast("Importação de contatos iniciada! Acompanhe o progresso na página de Contatos.");
    } catch (error) {
      toastError(error);
    }
  };

  const handleCancelContactsImport = () => {
    setContactsImportModalOpen(false);
    setContactsImportData(null);
  };

  const handleToggleReceiveComments = async (whatsApp) => {
    try {
      const newValue = !whatsApp.receiveComments;
      await api.put(`/whatsapp/${whatsApp.id}`, {
        receiveComments: newValue
      });
      showSuccessToast(
        newValue 
          ? i18n.t("connections.receiveComments.enabled") 
          : i18n.t("connections.receiveComments.disabled")
      );
    } catch (err) {
      toastError(err);
    }
  };

  const handleCopyWebhook = (url) => {
    navigator.clipboard.writeText(url); // Copia o token para a área de transferência    
  };

  const setConnectionLoading = (key, value) => {
    setConnectionActionLoading((prev) => ({ ...prev, [key]: value }));
  };

  const handleDiagnoseConnection = async (whatsApp) => {
    const key = `diagnose-${whatsApp.id}`;
    try {
      setConnectionLoading(key, true);
      setDiagnosticData({
        classification: "recovering",
        diagnosticState: "RECOVERING",
        finalState: "RECOVERING",
        elapsedMs: null,
        database: {
          status: whatsApp.status,
          hasQrcode: !!whatsApp.qrcode,
          qrcodeLength: whatsApp.qrcode?.length || 0,
          updatedAt: whatsApp.updatedAt
        },
        autoResult: {
          finalState: "RECOVERING",
          message: "Diagnosticando conexão e aguardando resultado real."
        }
      });
      setDiagnosticModalOpen(true);
      const { data } = await api.post(`/whatsappsession/${whatsApp.id}/auto-diagnose`);
      setDiagnosticData({
        ...(data?.diagnostics || data),
        autoResult: data
      });

      if (data?.connected) {
        showSuccessToast(data.message || "Conexão restabelecida automaticamente.");
        return;
      }

      if (data?.qrRequired) {
        showWarningToast(data.message || "Faça a releitura do QR Code.");
        setForceGenerateQrOnOpen(data.forceGenerateQr !== false);
        setSelectedWhatsApp(whatsApp);
        setQrModalOpen(true);
        return;
      }

      showWarningToast(data?.message || "Não foi possível restabelecer automaticamente.");
      setDiagnosticModalOpen(true);
    } catch (err) {
      toastError(err);
    } finally {
      setConnectionLoading(key, false);
    }
  };

  const handleRepairConnection = async (whatsApp) => {
    const key = `repair-${whatsApp.id}`;
    try {
      setConnectionLoading(key, true);
      const { data } = await api.post(`/whatsappsession/${whatsApp.id}/repair`);
      if (data?.repaired) {
        showSuccessToast("Conexão reparada sem gerar novo QR.");
      } else {
        showWarningToast(data?.message || "Reparo concluído, mas a conexão ainda não abriu.");
      }
    } catch (err) {
      toastError(err);
    } finally {
      setConnectionLoading(key, false);
    }
  };

  const handleRestartSocket = async (whatsApp) => {
    const key = `restart-${whatsApp.id}`;
    try {
      setConnectionLoading(key, true);
      const { data } = await api.post(`/whatsappsession/${whatsApp.id}/restart-socket`);
      if (data?.restarted) {
        showSuccessToast("Socket reiniciado sem apagar credenciais.");
      } else {
        showWarningToast(data?.message || "Socket não foi reiniciado.");
      }
    } catch (err) {
      toastError(err);
    } finally {
      setConnectionLoading(key, false);
    }
  };

  const openInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleOpenConfirmationModal = (action, whatsAppId) => {
    if (action === "disconnect") {
      setConfirmModalInfo({
        action: action,
        title: i18n.t("connections.confirmationModal.disconnectTitle"),
        message: "Esta ação desconectará o WhatsApp, apagará a sessão autenticada e exigirá leitura de um novo QR Code. Digite DESCONECTAR para confirmar.",
        whatsAppId: whatsAppId,
      });
    }

    if (action === "delete") {
      setConfirmModalInfo({
        action: action,
        title: i18n.t("connections.confirmationModal.deleteTitle"),
        message: i18n.t("connections.confirmationModal.deleteMessage"),
        whatsAppId: whatsAppId,
      });
    }
    if (action === "closedImported") {
      setConfirmModalInfo({
        action: action,
        title: i18n.t("connections.confirmationModal.closedImportedTitle"),
        message: i18n.t("connections.confirmationModal.closedImportedMessage"),
        whatsAppId: whatsAppId,
      });
    }

    setConfirmModalOpen(true);
  };

  const handleSubmitConfirmationModal = async () => {
    if (confirmModalInfo.action === "disconnect") {
      try {
        await api.delete(`/whatsappsession/${confirmModalInfo.whatsAppId}`, {
          data: {
            confirmLogout: true,
            expectedWhatsappId: confirmModalInfo.whatsAppId,
            expectedCompanyId: user.companyId,
            reason: "manual_user_logout",
            confirmationText: "DESCONECTAR"
          }
        });
      } catch (err) {
        toastError(err);
      }
    }

    if (confirmModalInfo.action === "delete") {
      try {
        await api.delete(`/whatsapp/${confirmModalInfo.whatsAppId}`);
        showSuccessToast(i18n.t("connections.toasts.deleted"));
      } catch (err) {
        toastError(err);
      }
    }
    if (confirmModalInfo.action === "closedImported") {
      try {
        await api.post(`/closedimported/${confirmModalInfo.whatsAppId}`);
        showSuccessToast(i18n.t("connections.toasts.closedimported"));
      } catch (err) {
        toastError(err);
      }
    }


    setConfirmModalInfo(confirmationModalInitialState);
  };


  const renderImportButton = (whatsApp) => {
    if (whatsApp?.statusImportMessages === "renderButtonCloseTickets") {
      return (
        <Tooltip title={i18n.t("connections.tooltips.closedImported")}>
          <Button
            style={{ marginLeft: 12 }}
            size="small"
            variant="outlined"
            color="primary"
            onClick={() => {
              handleOpenConfirmationModal("closedImported", whatsApp.id);
            }}
          >
            {i18n.t("connections.buttons.closedImported")}
          </Button>
        </Tooltip>
      );
    }

    if (whatsApp?.importOldMessages) {
      let isTimeStamp = !isNaN(
        new Date(Math.floor(whatsApp?.statusImportMessages)).getTime()
      );

      if (isTimeStamp) {
        const ultimoStatus = new Date(
          Math.floor(whatsApp?.statusImportMessages)
        ).getTime();
        const dataLimite = +add(ultimoStatus, { seconds: +35 }).getTime();
        if (dataLimite > new Date().getTime()) {
          return (
            <>
              <Tooltip title={i18n.t("connections.tooltips.preparing")}>
                <span>
                  <Button
                    disabled
                    style={{ marginLeft: 12 }}
                    size="small"
                    endIcon={
                      <CircularProgress
                        size={12}
                        className={classes.buttonProgress}
                      />
                    }
                    variant="outlined"
                    color="primary"
                  >
                    {i18n.t("connections.buttons.preparing")}
                  </Button>
                </span>
              </Tooltip>
            </>
          );
        }
      }
    }
  };

  // ✅ CORREÇÃO: Normalizar status vazio para "DISCONNECTED" e normalizar case
  const normalizeStatus = (status) => {
    if (!status || status === "") {
      return "DISCONNECTED";
    }
    // Normalizar case: converter para minúsculas para comparações consistentes
    const normalized = String(status).toLowerCase();
    // Mapear variações comuns para valores padrão
    if (normalized === "qrcode" || normalized === "qr_code" || normalized === "qr") {
      return "qrcode";
    }
    if (normalized === "disconnected" || normalized === "disconectado") {
      return "DISCONNECTED";
    }
    if (normalized === "connected" || normalized === "conectado") {
      return "CONNECTED";
    }
    if (normalized === "opening" || normalized === "abrindo") {
      return "OPENING";
    }
    // Retornar o status original se não houver mapeamento
    return status;
  };

  const renderActionButtons = (whatsApp) => {
    // ✅ CORREÇÃO: Normalizar status antes de usar
    const status = normalizeStatus(whatsApp.status);
    const originalStatus = String(whatsApp.status || "").trim();
    const isQrcode = status === "qrcode" || originalStatus.toUpperCase() === "QRCODE" || originalStatus.toLowerCase() === "qrcode";
    
    return (
      <>
        {whatsApp.channel === "whatsapp" && (
          <>
            <Tooltip title="Verifica a conexão e tenta restabelecer automaticamente. Se precisar, abre o QR Code para releitura.">
              <Button
                size="small"
                variant="outlined"
                color="default"
                startIcon={<Search />}
                disabled={!!connectionActionLoading[`diagnose-${whatsApp.id}`]}
                onClick={() => handleDiagnoseConnection(whatsApp)}
                style={{ width: "100%", marginBottom: 4 }}
              >
                {connectionActionLoading[`diagnose-${whatsApp.id}`] ? "Diagnosticando..." : "Diagnosticar"}
              </Button>
            </Tooltip>
          </>
        )}
        {whatsApp.channel === "whatsapp" && isQrcode && (
          <Can
            role={user.profile === "user" && user.allowConnections === "enabled" ? "admin" : user.profile}
            perform="connections-page:addConnection"
            yes={() => (
              <Tooltip title={i18n.t("connections.tooltips.qrcode")}>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={() => handleOpenQrModal(whatsApp)}
                  style={{ width: "100%" }}
                >
                  {i18n.t("connections.buttons.qrcode")}
                </Button>
              </Tooltip>
            )}
          />
        )}
        {whatsApp.channel === "whatsapp" && status === "DISCONNECTED" && null}
        {(whatsApp.channel === "whatsapp" && (status === "CONNECTED" ||
          status === "PAIRING" ||
          status === "TIMEOUT")) && (
            <Can
              role={user.profile}
              perform="connections-page:addConnection"
              yes={() => (
                <>
                  <Tooltip title={i18n.t("connections.tooltips.disconnect")}>
                    <Button
                      size="small"
                      variant="outlined"
                      color="secondary"
                      onClick={() => {
                        handleOpenConfirmationModal("disconnect", whatsApp.id);
                      }}
                    >
                      {i18n.t("connections.buttons.disconnect")}
                    </Button>
                  </Tooltip>

                  {renderImportButton(whatsApp)}
                </>
              )}
            />
          )}
        {(whatsApp.channel === "whatsapp" && status === "OPENING") && (
          <>
            <Tooltip title={i18n.t("connections.tooltips.connecting")}>
              <span>
                <Button size="small" variant="outlined" disabled style={{ width: "100%", marginBottom: 4 }}>
                  {i18n.t("connections.buttons.connecting") || "Conectando"}
                </Button>
              </span>
            </Tooltip>
            {(!whatsApp.qrcode || whatsApp.qrcode === "" || status !== "qrcode") && (
              <Can
                role={user.profile === "user" && user.allowConnections === "enabled" ? "admin" : user.profile}
                perform="connections-page:addConnection"
                yes={() => (
                  <Tooltip title="Gerar novo QR Code quando a conexão ficar presa sem socket ativo.">
                    <span>
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        disabled={!!connectionActionLoading[`qr-${whatsApp.id}`]}
                        onClick={() => handleRequestNewQrCode(whatsApp)}
                        style={{ width: "100%" }}
                      >
                        {connectionActionLoading[`qr-${whatsApp.id}`] ? "Verificando..." : i18n.t("connections.buttons.qrcode")}
                      </Button>
                    </span>
                  </Tooltip>
                )}
              />
            )}
          </>
        )}
      </>
    );
  };

  const renderStatusToolTips = (whatsApp) => {
    // ✅ CORREÇÃO: Normalizar status antes de usar
    const status = normalizeStatus(whatsApp.status);
    
    return (
      <div className={classes.customTableCell}>
        {status === "DISCONNECTED" && (
          <CustomToolTip
            title={i18n.t("connections.toolTips.disconnected.title")}
            content={i18n.t("connections.toolTips.disconnected.content")}
          >
            <SignalCellularConnectedNoInternet0Bar color="secondary" />
          </CustomToolTip>
        )}
        {status === "OPENING" && (
          <>
            {/* ✅ CORREÇÃO: Se OPENING sem qrcode, não mostrar spinner infinito */}
            {/* ✅ VALIDAÇÃO: Só considerar qrcode válido se status for "qrcode" */}
            {status === "qrcode" && whatsApp.qrcode && whatsApp.qrcode !== "" ? (
              <CustomToolTip
                title={i18n.t("connections.toolTips.qrcode.title")}
                content={i18n.t("connections.toolTips.qrcode.content")}
              >
                <CircularProgress size={24} className={classes.buttonProgress} />
              </CustomToolTip>
            ) : (
              <CustomToolTip
                title={i18n.t("connections.toolTips.opening.title")}
                content={i18n.t("connections.toolTips.opening.content")}
              >
                <SignalCellularConnectedNoInternet2Bar color="secondary" />
              </CustomToolTip>
            )}
          </>
        )}
        {status === "qrcode" && (
          <CustomToolTip
            title={i18n.t("connections.toolTips.qrcode.title")}
            content={i18n.t("connections.toolTips.qrcode.content")}
          >
            <CropFree />
          </CustomToolTip>
        )}
        {status === "CONNECTED" && (
          <CustomToolTip title={i18n.t("connections.toolTips.connected.title")}>
            <SignalCellular4Bar style={{ color: green[500] }} />
          </CustomToolTip>
        )}
        {(status === "TIMEOUT" || status === "PAIRING") && (
          <CustomToolTip
            title={i18n.t("connections.toolTips.timeout.title")}
            content={i18n.t("connections.toolTips.timeout.content")}
          >
            <SignalCellularConnectedNoInternet2Bar color="secondary" />
          </CustomToolTip>
        )}
        {status === "REINICIANDO" && (
          <CustomToolTip
            title={i18n.t("connections.toolTips.restarting.title")}
            content={i18n.t("connections.toolTips.restarting.content")}
          >
            <CircularProgress size={24} className={classes.buttonProgress} />
          </CustomToolTip>
        )}
      </div>
    );
  };

  const restartWhatsapps = async () => {

    try {
      await api.post(`/whatsapp-restart/`);
      showSuccessToast(i18n.t("connections.waitConnection"));
    } catch (err) {
      toastError(err);
    }
  }

  const handleOpenTransferModal = () => {
    setTransferModalOpen(true);
  };

  const handleCloseTransferModal = () => {
    setTransferModalOpen(false);
    setSourceConnection("");
    setTargetConnection("");
  };

  const handleCloseTransferProgressModal = () => {
    setTransferProgressModalOpen(false);
    setTransferProgress({ current: 0, total: 0, percentage: 0 });
  };

  const handleTransferTickets = async () => {
    if (!sourceConnection || !targetConnection) {
      toastError("Selecione as conexões de origem e destino");
      return;
    }

    if (sourceConnection === targetConnection) {
      toastError("As conexões de origem e destino devem ser diferentes");
      return;
    }

    try {
      const response = await api.post(`/transfer-tickets`, {
        sourceConnectionId: sourceConnection,
        targetConnectionId: targetConnection
      });

      if (response.data.requiresProgress) {
        setTransferModalOpen(false);
        setTransferProgressModalOpen(true);
        setTransferProgress({ current: 0, total: response.data.totalTickets, percentage: 0 });
      } else {
        showSuccessToast(`Tickets transferidos com sucesso! ${response.data.transferred || 0} tickets transferidos.`);
        handleCloseTransferModal();
      }
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenPreDeleteModal = (whatsAppId) => {
    setWhatsAppToDelete(whatsAppId);
    setPreDeleteModalOpen(true);
  };

  const handleClosePreDeleteModal = () => {
    setPreDeleteModalOpen(false);
    setWhatsAppToDelete(null);
  };

  const handleConfirmTransferDone = () => {
    setPreDeleteModalOpen(false);
    handleOpenConfirmationModal("delete", whatsAppToDelete);
  };

  const formatDiagnosticValue = (value) => {
    if (value === true) return "SIM";
    if (value === false) return "NÃO";
    if (value === null || value === undefined || value === "") return "-";
    return String(value);
  };

  const renderDiagnosticSection = (title, rows) => (
    <Box style={{ marginBottom: 16 }}>
      <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 6 }}>
        {title}
      </Typography>
      {rows.map(([label, value]) => (
        <Box key={label} display="flex" justifyContent="space-between" style={{ gap: 16, padding: "2px 0" }}>
          <Typography variant="body2" color="textSecondary">{label}</Typography>
          <Typography variant="body2" style={{ textAlign: "right", wordBreak: "break-word" }}>
            {formatDiagnosticValue(value)}
          </Typography>
        </Box>
      ))}
    </Box>
  );

  const classificationLabel = (classification) => {
    if (classification === "healthy") return "Saudável";
    if (classification === "recovering") return "Recuperando";
    if (classification === "recoverable") return "Reparo necessário";
    if (classification === "needs_intervention") return "Necessita intervenção";
    if (classification === "qr_required") return "Novo QR necessário";
    return classification || "-";
  };

  const diagnosticStateLabel = (state) => {
    if (state === "HEALTHY") return "Saudável";
    if (state === "RECOVERING") return "Recuperando";
    if (state === "RECOVERED") return "Conectado";
    if (state === "QR_REQUIRED") return "QR necessário";
    if (state === "REPAIR_REQUIRED") return "Reparo necessário";
    if (state === "MANUAL_ACTION_REQUIRED") return "Ação manual necessária";
    if (state === "FAILED") return "Falhou";
    return state || "-";
  };

  return (
    <PageBase
      className="connections-page app-page-root"
      title={`${i18n.t("connections.title")} (${whatsApps.length})`}
      actions={
        !(user.profile === "user" && user.allowConnections === "disabled") && (
          <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
            <Tooltip title={i18n.t("connections.tooltips.transferTickets")}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleOpenTransferModal}
              >
                Transferir Tickets
              </Button>
            </Tooltip>

            <Tooltip title={i18n.t("connections.tooltips.restartConnections")}>
              <Button
                variant="contained"
                color="primary"
                onClick={restartWhatsapps}
              >
                {i18n.t("connections.restartConnections")}
              </Button>
            </Tooltip>

            <Tooltip title={i18n.t("connections.tooltips.callSupport")}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => openInNewTab(`https://wa.me/${process.env.REACT_APP_NUMBER_SUPPORT}`)}
              >
                {i18n.t("connections.callSupport")}
              </Button>
            </Tooltip>
            <PopupState variant="popover" popupId="demo-popup-menu">
              {(popupState) => (
                <React.Fragment>
                  <Can
                    role={user.profile}
                    perform="connections-page:addConnection"
                    yes={() => (
                      <>
                        <Tooltip title={i18n.t("connections.tooltips.newConnection")}>
                          <Button
                            variant="contained"
                            color="primary"
                            {...bindTrigger(popupState)}
                          >
                            {i18n.t("connections.newConnection")}
                          </Button>
                        </Tooltip>
                        <Menu {...bindMenu(popupState)}>
                          {/* WHATSAPP */}
                          <MenuItem
                            disabled={planConfig?.plan?.useWhatsapp ? false : true}
                            onClick={() => {
                              handleOpenWhatsAppModal();
                              popupState.close();
                            }}
                          >
                            <WhatsApp
                              fontSize="small"
                              style={{
                                marginRight: "10px",
                                color: "#25D366",
                              }}
                            />
                            WhatsApp
                          </MenuItem>
                          {/* WHATSAPP OFICIAL */}
                          <MenuItem
                            disabled={planConfig?.plan?.useWhatsappOfficial ? false : true}
                            onClick={() => {
                              handleOpenWhatsAppModal("whatsapp_oficial");
                              popupState.close();
                            }}
                          >
                            <WhatsApp
                              fontSize="small"
                              style={{
                                marginRight: "10px",
                                color: "#25D366",
                              }}
                            />
                            WhatsApp Oficial
                          </MenuItem>
                          {/* FACEBOOK */}
                          <FacebookLogin
                            appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                            autoLoad={false}
                            fields="name,email,picture"
                            version="9.0"
                            scope={process.env.REACT_APP_REQUIRE_BUSINESS_MANAGEMENT?.toUpperCase() === "TRUE" ?
                              "public_profile,pages_messaging,pages_show_list,pages_manage_metadata,pages_read_engagement,business_management"
                              : "public_profile,pages_messaging,pages_show_list,pages_manage_metadata,pages_read_engagement"}
                            callback={responseFacebook}
                            render={(renderProps) => (
                              <MenuItem
                                disabled={planConfig?.plan?.useFacebook ? false : true}
                                onClick={renderProps.onClick}
                              >
                                <Facebook
                                  fontSize="small"
                                  style={{
                                    marginRight: "10px",
                                    color: "#3b5998",
                                  }}
                                />
                                Facebook
                              </MenuItem>
                            )}
                          />
                          {/* INSTAGRAM */}
                          <FacebookLogin
                            appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                            autoLoad={false}
                            fields="name,email,picture"
                            version="9.0"
                            scope={process.env.REACT_APP_REQUIRE_BUSINESS_MANAGEMENT?.toUpperCase() === "TRUE" ?
                              "public_profile,instagram_basic,instagram_manage_messages,pages_messaging,pages_show_list,pages_manage_metadata,pages_read_engagement,business_management"
                              : "public_profile,instagram_basic,instagram_manage_messages,pages_messaging,pages_show_list,pages_manage_metadata,pages_read_engagement"}
                            callback={responseInstagram}
                            render={(renderProps) => (
                              <MenuItem
                                disabled={planConfig?.plan?.useInstagram ? false : true}
                                onClick={renderProps.onClick}
                              >
                                <Instagram
                                  fontSize="small"
                                  style={{
                                    marginRight: "10px",
                                    color: "#e1306c",
                                  }}
                                />
                                Instagram
                              </MenuItem>
                            )}
                          />
                        </Menu>
                      </>
                    )}
                  />
                </React.Fragment>
              )}
            </PopupState>
          </div>
        )
      }
      containerProps={{
        className: classes.mainPaper,
      }}
    >
      <ConfirmationModal
        title={confirmModalInfo.title}
        open={confirmModalOpen}
        onClose={setConfirmModalOpen}
        onConfirm={handleSubmitConfirmationModal}
        confirmationText={confirmModalInfo.action === "disconnect" ? "DESCONECTAR" : undefined}
        confirmationLabel={confirmModalInfo.action === "disconnect" ? "Digite DESCONECTAR" : undefined}
      >
        {confirmModalInfo.message}
      </ConfirmationModal>

      <Dialog
        open={diagnosticModalOpen}
        onClose={() => setDiagnosticModalOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle className={`${classes.dialogTitle} ${useGradient ? classes.gradientBackground : classes.solidBackground}`}>
          Diagnóstico da Conexão
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          {diagnosticData && (
            <>
              {diagnosticData.autoResult?.message && (
                <Typography variant="h6" color={diagnosticData.autoResult?.qrRequired ? "secondary" : "primary"} style={{ marginBottom: 16 }}>
                  {diagnosticData.autoResult.message}
                </Typography>
              )}
              {renderDiagnosticSection("Resultado", [
                ["Estado final", diagnosticStateLabel(diagnosticData.autoResult?.finalState || diagnosticData.finalState || diagnosticData.diagnosticState)],
                ["Ação executada", diagnosticData.autoResult?.action],
                ["Conectado", diagnosticData.autoResult?.connected ?? diagnosticData.connected],
                ["QR necessário", diagnosticData.autoResult?.qrRequired ?? diagnosticData.qrRequired],
                ["QR disponível", diagnosticData.autoResult?.qrAvailable ?? diagnosticData.qrAvailable],
                ["DiagnosticId", diagnosticData.autoResult?.diagnosticId || diagnosticData.diagnosticId],
              ])}
              {renderDiagnosticSection("Socket", [
                ["Existe socket?", diagnosticData.socket?.exists],
                ["Socket aberto?", diagnosticData.socket?.open],
                ["Socket fechado?", diagnosticData.socket?.closed],
                ["Socket destruído?", diagnosticData.socket?.destroyed],
                ["Tempo ativo", diagnosticData.socket?.activeMs ? `${Math.round(diagnosticData.socket.activeMs / 1000)}s` : null],
                ["Último connection.update", diagnosticData.socket?.lastConnectionUpdateAt],
                ["Tempo desde último update", diagnosticData.socket?.msSinceLastConnectionUpdate ? `${Math.round(diagnosticData.socket.msSinceLastConnectionUpdate / 1000)}s` : null],
              ])}
              {renderDiagnosticSection("AuthenticationState", [
                ["Credenciais Redis", diagnosticData.authState?.redisHasCreds],
                ["Signal Keys Redis", `${diagnosticData.authState?.signalKeyCount || 0}`],
                ["Backup existe", diagnosticData.authState?.backupExists],
                ["Backup íntegro", diagnosticData.authState?.backupValid],
                ["Checksum", diagnosticData.authState?.checksumValid],
                ["Revision", diagnosticData.authState?.revision],
                ["Último backup", diagnosticData.authState?.backedUpAt],
              ])}
              {renderDiagnosticSection("Baileys", [
                ["Último creds.update", diagnosticData.baileys?.lastCredsUpdateAt],
                ["DisconnectReason", diagnosticData.baileys?.disconnectReason],
                ["RestartRequired", diagnosticData.baileys?.restartRequired],
                ["LoggedOut", diagnosticData.baileys?.loggedOut],
              ])}
              {renderDiagnosticSection("Listeners", Object.entries(diagnosticData.listeners || {}).map(([eventName, data]) => [
                eventName,
                `${data.registered}/${data.expected}`
              ]))}
              {renderDiagnosticSection("Redis", [
                ["Credenciais", diagnosticData.redis?.hasCreds],
                ["Keys", diagnosticData.redis?.signalKeyCount],
                ["TTL creds", diagnosticData.redis?.credsTtl],
                ["AOF", diagnosticData.redis?.persistence?.aofEnabled],
                ["RDB changes", diagnosticData.redis?.persistence?.rdbChangesSinceLastSave],
                ["Última gravação", diagnosticData.redis?.lastWrite],
              ])}
              {renderDiagnosticSection("Comunicação", [
                ["Último envio", diagnosticData.communication?.lastSentAt],
                ["Último recebimento", diagnosticData.communication?.lastReceivedAt],
                ["Último ACK", diagnosticData.communication?.lastAckAt],
                ["ACK", diagnosticData.communication?.lastAck],
                ["Último ping", diagnosticData.communication?.lastPingAt],
              ])}
              {renderDiagnosticSection("Banco", [
                ["Status", diagnosticData.database?.status],
                ["QR", diagnosticData.database?.hasQrcode],
                ["QR length", diagnosticData.database?.qrcodeLength],
                ["Session", diagnosticData.database?.session],
                ["Warmup", diagnosticData.database?.campaignWarmupStage],
                ["CampaignBlockedUntil", diagnosticData.database?.campaignBlockedUntil],
                ["updatedAt", diagnosticData.database?.updatedAt],
              ])}
              <Typography variant="h6" color="primary">
                Resultado Geral: {classificationLabel(diagnosticData.classification)}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Tempo do diagnóstico: {diagnosticData.elapsedMs}ms
              </Typography>
            </>
          )}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          {diagnosticData?.recommendedActions?.restoreBackup && qrSafetyWhatsApp && (
            <Button color="primary" variant="contained" onClick={() => handleRepairConnection(qrSafetyWhatsApp)}>
              Restaurar Backup
            </Button>
          )}
          <Button onClick={() => setDiagnosticModalOpen(false)} color="default">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={qrSafetyModalOpen}
        onClose={() => setQrSafetyModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle className={`${classes.dialogTitle} ${useGradient ? classes.gradientBackground : classes.solidBackground}`}>
          Atenção
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <Typography variant="body1" style={{ marginBottom: 12 }}>
            Esta operação somente deve ser utilizada quando Redis não possui AuthenticationState e não existe backup válido, ou quando você deseja substituir o aparelho conectado.
          </Typography>
          <Typography variant="body1" style={{ marginBottom: 12 }}>
            Foi encontrado um AuthenticationState íntegro. Deseja tentar recuperar automaticamente antes de gerar um novo QR?
          </Typography>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              setQrSafetyModalOpen(false);
              handleRepairConnection(qrSafetyWhatsApp);
            }}
          >
            Recuperar
          </Button>
          <Button onClick={() => setQrSafetyModalOpen(false)} color="default">
            Cancelar
          </Button>
          <Button color="secondary" onClick={() => handleGenerateQrAnyway(qrSafetyWhatsApp)}>
            Gerar QR Mesmo Assim
          </Button>
        </DialogActions>
      </Dialog>
      
      {/* ✅ NOVO: Modal de confirmação para importação de contatos */}
      <Dialog
        open={contactsImportModalOpen}
        onClose={handleCancelContactsImport}
        aria-labelledby="contacts-import-dialog-title"
        aria-describedby="contacts-import-dialog-description"
      >
        <DialogTitle id="contacts-import-dialog-title">
          {i18n.t("connections.contactsImport.title")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="contacts-import-dialog-description">
            {contactsImportData?.message || 
             i18n.t("connections.contactsImport.message", { count: contactsImportData?.totalContacts || 0 })}
            <br /><br />
            <strong>{i18n.t("common.note")}:</strong> {i18n.t("connections.contactsImport.note")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelContactsImport} color="secondary">
            {i18n.t("connections.contactsImport.later")}
          </Button>
          <Button onClick={handleConfirmContactsImport} color="primary" variant="contained" autoFocus>
            {i18n.t("connections.contactsImport.confirm")}
          </Button>
        </DialogActions>
      </Dialog>
      
      {qrModalOpen && (
        <QrcodeModal
          open={qrModalOpen}
          onClose={handleCloseQrModal}
          whatsAppId={!whatsAppModalOpen && selectedWhatsApp?.id}
          requestFreshQrOnOpen
          forceGenerateQrOnOpen={forceGenerateQrOnOpen}
        />
      )}
      <WhatsAppModal
        open={whatsAppModalOpen}
        onClose={handleCloseWhatsAppModal}
        whatsAppId={!qrModalOpen && selectedWhatsApp?.id}
        channel={channel}
      />
      <Dialog
        open={transferModalOpen}
        onClose={handleCloseTransferModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle className={`${classes.dialogTitle} ${useGradient ? classes.gradientBackground : classes.solidBackground}`}>
          {i18n.t("connections.transfer.title")}
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <Typography variant="body1" style={{ marginBottom: 24, lineHeight: 1.6 }}>
            {i18n.t("connections.transfer.descriptionStart")} <strong>{i18n.t("connections.transfer.source").toLowerCase()}</strong> {i18n.t("connections.transfer.descriptionMiddle")} 
            <strong>{i18n.t("connections.transfer.target").toLowerCase()}</strong> {i18n.t("connections.transfer.descriptionEnd")}
          </Typography>
          
          <div style={{ display: 'flex', alignItems: 'center', gap: 24, marginBottom: 24 }}>
            <FormControl fullWidth>
              <InputLabel>{i18n.t("connections.transfer.source")}</InputLabel>
              <Select
                value={sourceConnection}
                onChange={(e) => setSourceConnection(e.target.value)}
                label={i18n.t("connections.transfer.source")}
              >
                {whatsApps.map((whatsApp) => (
                  <MuiMenuItem key={whatsApp.id} value={whatsApp.id}>
                    {whatsApp.name}
                  </MuiMenuItem>
                ))}
              </Select>
            </FormControl>

            <div style={{ fontSize: 24, color: '#4caf50', fontWeight: 'bold' }}>
              →
            </div>

            <FormControl fullWidth>
              <InputLabel>{i18n.t("connections.transfer.target")}</InputLabel>
              <Select
                value={targetConnection}
                onChange={(e) => setTargetConnection(e.target.value)}
                label={i18n.t("connections.transfer.target")}
              >
                {whatsApps.map((whatsApp) => (
                  <MuiMenuItem key={whatsApp.id} value={whatsApp.id}>
                    {whatsApp.name}
                  </MuiMenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button onClick={handleCloseTransferModal} color="default">
            CANCELAR
          </Button>
          <Button onClick={handleTransferTickets} color="primary" variant="contained">
            TRANSFERIR
          </Button>
        </DialogActions>
       </Dialog>
       <Dialog
         open={transferProgressModalOpen}
         onClose={handleCloseTransferProgressModal}
         maxWidth="sm"
         fullWidth
         disableBackdropClick
         disableEscapeKeyDown
       >
         <DialogTitle className={`${classes.dialogTitle} ${useGradient ? classes.gradientBackground : classes.solidBackground}`}>
           Transferindo Tickets
         </DialogTitle>
         <DialogContent className={classes.dialogContent}>
           <div style={{ textAlign: 'center', padding: '20px 0' }}>
             <Typography variant="h6" style={{ marginBottom: 16 }}>
               Progresso da Transferência
             </Typography>
             
             <Box position="relative" display="inline-flex" marginBottom={2}>
               <CircularProgress 
                 variant="determinate" 
                 value={transferProgress.percentage} 
                 size={80}
                 thickness={4}
               />
               <Box
                 top={0}
                 left={0}
                 bottom={0}
                 right={0}
                 position="absolute"
                 display="flex"
                 alignItems="center"
                 justifyContent="center"
               >
                 <Typography variant="caption" component="div" color="textSecondary" style={{ fontSize: '14px', fontWeight: 'bold' }}>
                   {transferProgress.percentage}%
                 </Typography>
               </Box>
             </Box>

             <Typography variant="body1" style={{ marginTop: 16 }}>
               {transferProgress.current} de {transferProgress.total} tickets transferidos
             </Typography>
             
             <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
               Por favor, aguarde enquanto os tickets são transferidos...
             </Typography>
           </div>
         </DialogContent>
       </Dialog>
       <Dialog
         open={preDeleteModalOpen}
         onClose={handleClosePreDeleteModal}
         maxWidth="sm"
         fullWidth
       >
        <DialogTitle className={`${classes.dialogTitle} ${useGradient ? classes.gradientBackground : classes.solidBackground}`}>
          Transferência de Tickets
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <Typography variant="body1" style={{ marginBottom: 16 }}>
            Antes de excluir esta conexão, você já fez a transferência dos tickets para outra conexão?
          </Typography>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
           <Button onClick={handleClosePreDeleteModal} color="default">
             NÃO
           </Button>
           <Button onClick={handleConfirmTransferDone} color="primary" variant="contained">
             SIM
           </Button>
         </DialogActions>
       </Dialog>
      {user.profile === "user" && user.allowConnections === "disabled" ? (
        <ForbiddenPage />
      ) : (
        <>
          {statusImport?.all ? (
            <div style={{ margin: "auto", marginBottom: 12 }}>
              <Tooltip title={i18n.t("connections.tooltips.importMessages")}>
                <Card className={classes.root}>
                  <CardContent className={classes.content}>
                    <Typography component="h5" variant="h5">
                      {statusImport?.this === -1 ? i18n.t("connections.buttons.preparing") : i18n.t("connections.buttons.importing")}
                    </Typography>
                    {statusImport?.this === -1 ? (
                      <Typography component="h6" variant="h6" align="center">
                        <CircularProgress size={24} />
                      </Typography>
                    ) : (
                      <>
                        <Typography component="h6" variant="h6" align="center">
                          {`${i18n.t(`connections.typography.processed`)} ${statusImport?.this} ${i18n.t(`connections.typography.in`)} ${statusImport?.all}  ${i18n.t(`connections.typography.date`)}: ${statusImport?.date} `}
                        </Typography>
                        <Typography align="center">
                          <CircularProgressWithLabel
                            style={{ margin: "auto" }}
                            value={(statusImport?.this / statusImport?.all) * 100}
                          />
                        </Typography>
                      </>
                    )}
                  </CardContent>
                </Card>
              </Tooltip>
            </div>
          ) : null}

          <div className="page-table-wrapper app-table-zebra">
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell align="center">{i18n.t("connections.table.channel")}</TableCell>
                  <TableCell align="center">{i18n.t("connections.table.color")}</TableCell>
                  <TableCell align="center">{i18n.t("connections.table.name")}</TableCell>
                  <TableCell align="center">{i18n.t("connections.table.number")}</TableCell>
                  <TableCell align="center">{i18n.t("connections.table.status")}</TableCell>
                  <TableCell align="center">{i18n.t("connections.table.session")}</TableCell>
                  <TableCell align="center">{i18n.t("connections.table.lastUpdate")}</TableCell>
                  <TableCell align="center">{i18n.t("connections.table.default")}</TableCell>
                  <TableCell align="center">{i18n.t("connections.table.receiveComments")}</TableCell>
                  <Can
                    role={user.profile === "user" && user.allowConnections === "enabled" ? "admin" : user.profile}
                    perform="connections-page:addConnection"
                    yes={() => (
                      <TableCell align="center">{i18n.t("connections.table.actions")}</TableCell>
                    )}
                  />
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRowSkeleton />
                ) : (
                  <>
                    {whatsApps?.length > 0 &&
                      whatsApps.map((whatsApp) => (
                        <TableRow key={whatsApp.id}>
                          <TableCell align="center">{IconChannel(whatsApp.channel)}</TableCell>
                          <TableCell align="center">
                            <div className={classes.customTableCell}>
                              <span
                                style={{
                                  backgroundColor: whatsApp.color,
                                  width: 60,
                                  height: 20,
                                  alignSelf: "center",
                                }}
                              />
                            </div>
                          </TableCell>
                          <TableCell align="center">{whatsApp.name}</TableCell>
                          <TableCell align="center">
                            {whatsApp.channel === 'whatsapp' && whatsApp.number
                              ? <FormattedPhoneNumber serializedId={whatsApp.number} />
                              : whatsApp.channel === 'whatsapp_oficial' && whatsApp.phone_number
                                  ? <FormattedPhoneNumber serializedId={whatsApp.phone_number} />
                                  : "-"}
                          </TableCell>
                          <TableCell align="center">{renderStatusToolTips(whatsApp)}</TableCell>
                          <TableCell align="center">
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" }}>
                              {renderActionButtons(whatsApp)}
                            </div>
                          </TableCell>
                          <TableCell align="center">{format(parseISO(whatsApp.updatedAt), "dd/MM/yy HH:mm")}</TableCell>
                          <TableCell align="center">
                            {whatsApp.isDefault && (
                              <Tooltip title={i18n.t("connections.tooltips.defaultConnection")}>
                                <div className={classes.customTableCell}>
                                  <CheckCircle style={{ color: green[500] }} />
                                </div>
                              </Tooltip>
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {(whatsApp.channel === "facebook" || whatsApp.channel === "instagram") && (
                              <Tooltip 
                                title={
                                  whatsApp.receiveComments 
                                    ? i18n.t("connections.receiveComments.tooltip.enabled")
                                    : i18n.t("connections.receiveComments.tooltip.disabled")
                                }
                              >
                                <Switch
                                  checked={whatsApp.receiveComments !== false}
                                  onChange={() => handleToggleReceiveComments(whatsApp)}
                                  color="primary"
                                  size="small"
                                />
                              </Tooltip>
                            )}
                          </TableCell>
                          <Can
                            role={user.profile}
                            perform="connections-page:addConnection"
                            yes={() => (
                              <TableCell align="center">
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px", flexWrap: "wrap" }}>
                                  <Tooltip title={i18n.t("connections.tooltips.edit")}>
                                    <IconButton
                                      size="small"
                                      onClick={() => handleEditWhatsApp(whatsApp)}
                                    >
                                      <Edit />
                                    </IconButton>
                                  </Tooltip>

                                  {whatsApp.channel === "whatsapp" && (
                                    <Tooltip title={i18n.t("connections.tooltips.disconnect")}>
                                      <IconButton
                                        size="small"
                                        onClick={() => {
                                          handleOpenConfirmationModal("disconnect", whatsApp.id);
                                        }}
                                      >
                                        <PowerSettingsNew />
                                      </IconButton>
                                    </Tooltip>
                                  )}

                                  <Tooltip title={i18n.t("connections.tooltips.delete")}>
                                    <IconButton
                                      size="small"
                                      onClick={(e) => {
                                        handleOpenPreDeleteModal(whatsApp.id);
                                      }}
                                    >
                                      <DeleteOutline />
                                    </IconButton>
                                  </Tooltip>
                                  {whatsApp.channel === "whatsapp_oficial" && (
                                    <>
                                      <Tooltip title={i18n.t("connections.tooltips.syncTemplates")}>
                                        <IconButton
                                          size="small"
                                          aria-label={i18n.t("connections.aria.syncTemplates")}
                                          onClick={(e) => {
                                            handleSyncTemplates(whatsApp.id);
                                          }}
                                        >
                                          <Sync />
                                        </IconButton>
                                      </Tooltip>
                                      <Tooltip title={i18n.t("connections.tooltips.copyWebhook")}>
                                        <IconButton
                                          size="small"
                                          aria-label={i18n.t("connections.aria.copyWebhook")}
                                          onClick={(e) => {
                                            handleCopyWebhook(whatsApp.waba_webhook);
                                          }}
                                        >
                                          <WebhookIcon />
                                        </IconButton>
                                      </Tooltip>
                                    </>
                                  )}
                                </div>
                              </TableCell>
                            )}
                          />
                        </TableRow>
                      ))}
                  </>
                )}
              </TableBody>
            </Table>
          </div>
        </>
      )}
    </PageBase>
  );
};

export default Connections;
